import { treaty } from "@elysiajs/eden";
import type { App } from "@postman/api/app";

/**
 * The API client.
 *
 * Types come from the server's `App` type through Eden Treaty, so there are no
 * hand-written request or response shapes anywhere in the portal. Changing a
 * route's return type in api/src/index.ts breaks `pnpm --filter @postman/portal
 * typecheck` rather than producing an `undefined` in a component three weeks
 * later.
 *
 * The origin is deliberately `window.location.origin`: site, portal and API are
 * one origin in production and one origin in development (both through the
 * Next server), and that is precisely what lets the session cookie stay
 * SameSite=Lax with no CORS anywhere.
 */
const client = treaty<App>(window.location.origin, {
  fetch: { credentials: "include" },
});

/**
 * Treaty's proxy mirrors the URL, prefix included, so the raw client reads
 * `client.api.me.get()`. Descending once here is what keeps every call site to
 * `api.me.get()` — and it is a property access on a proxy, not a request, so
 * it costs nothing.
 */
export const api = client.api;

/** The same prefix as a string, for plain <a href> to authenticated files. */
export const API_BASE = "/api";
